import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MiniKit } from '@worldcoin/minikit-js';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { walletAppConfig } from './lib/config';
import { relayCentralSsoPopupCallback } from './lib/centralSso';
import './index.css';
import './i18n';

const hasRelayedCentralSsoPopupCallback = relayCentralSsoPopupCallback();

if (!hasRelayedCentralSsoPopupCallback) {
  try {
    MiniKit.install(walletAppConfig.appId || undefined);
  } catch (error) {
    console.warn('[Wallet Mini App] MiniKit initialization deferred:', error);
  }

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <AuthProvider>
        <App />
      </AuthProvider>
    </StrictMode>,
  );
}
